export default{
    billOfLandings: [],
    billOfLanding: null,
    pagesCount: 0,
    totalCountData: 0
}